import * as React from 'react'

const GoldMedal = React.forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement>
>((props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 33"
    fill="none"
    ref={ref}
    {...props}
  >
    <path
      d="M18.7681 11.86L13.5481 3.28001C13.2081 2.70001 12.5981 2.35001 11.9281 2.35001H5.3381C3.8881 2.35001 2.9781 3.91001 3.6881 5.17001C5.00774 7.50473 6.87026 9.48729 9.1181 10.95C9.8781 11.54 10.8181 11.86 11.7881 11.86H18.7681Z"
      fill="#0074BA"
    />
    <path
      d="M26.658 2.35001H20.068C19.398 2.35001 18.788 2.70001 18.448 3.28001L13.228 11.86H20.218C21.188 11.86 22.118 11.54 22.888 10.95C25.138 9.49001 26.998 7.51001 28.318 5.17001C29.018 3.91001 28.108 2.35001 26.658 2.35001Z"
      fill="#00A6ED"
    />
    <path
      d="M15.9902 30.35C21.5352 30.35 26.0302 25.743 26.0302 20.06C26.0302 14.377 21.5352 9.77 15.9902 9.77C10.4452 9.77 5.9502 14.377 5.9502 20.06C5.9502 25.743 10.4452 30.35 15.9902 30.35Z"
      fill="#FFB02E"
    />
    <path
      d="M14.0762 16.391C14.0762 16.1258 14.1815 15.8714 14.3691 15.6839C14.5566 15.4964 14.811 15.391 15.0762 15.391H16.0002C16.2654 15.391 16.5197 15.4964 16.7073 15.6839C16.8948 15.8714 17.0002 16.1258 17.0002 16.391V23.35C17.0002 23.6152 16.8948 23.8696 16.7073 24.0571C16.5197 24.2446 16.2654 24.35 16.0002 24.35C15.735 24.35 15.4806 24.2446 15.2931 24.0571C15.1055 23.8696 15.0002 23.6152 15.0002 23.35V17.388C14.7489 17.3689 14.514 17.2555 14.3427 17.0706C14.1714 16.8858 14.0762 16.643 14.0762 16.391Z"
      fill="#6D4534"
    />
    <path
      d="M16 29.11C13.64 29.11 11.42 28.17 9.76002 26.46C8.0895 24.7497 7.15913 22.4507 7.17002 20.06C7.17002 17.64 8.09002 15.37 9.76002 13.66C10.5703 12.8226 11.5407 12.1567 12.6136 11.702C13.6864 11.2472 14.8398 11.0129 16.005 11.0129C17.1703 11.0129 18.3236 11.2472 19.3965 11.702C20.4693 12.1567 21.4397 12.8226 22.25 13.66C25.69 17.19 25.69 22.93 22.25 26.46C20.57 28.17 18.35 29.11 16 29.11ZM15.99 12.24C14.04 12.24 12.08 13 10.6 14.53C9.16013 16.0095 8.35925 17.9955 8.37002 20.06C8.37002 22.15 9.16002 24.11 10.6 25.59C11.2982 26.3146 12.1354 26.8909 13.0616 27.2844C13.9877 27.6779 14.9837 27.8805 15.99 27.88C18.03 27.88 19.94 27.07 21.38 25.59C24.35 22.54 24.35 17.58 21.38 14.53C20.6825 13.8045 19.8454 13.2275 18.9191 12.834C17.9928 12.4404 16.9965 12.2384 15.99 12.24Z"
      fill="#FCD53F"
    />
  </svg>
))

GoldMedal.displayName = 'GoldMedal'

export { GoldMedal }
